import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]

  refresh() {
    this.element.disabled = true
    this.iconTarget.className = "spinner-border spinner-border-sm"

    requestAnimationFrame(() => window.location.reload())
  }
}
